import { useAccount, useReadContract } from "wagmi";
import { useMemo } from "react";
import { StakingManagerAbi, contractAddresses } from "@meta";
import { formatUnits } from "viem";

export const useGetChiRewards = () => {
  const { address } = useAccount();

  const { data: uscEthData } = useReadContract({
    abi: StakingManagerAbi,
    functionName: "getUserTotalRewardsForToken",
    address: contractAddresses.StakingManager,
    args: [address!, contractAddresses.USC_ETH_LP, contractAddresses.CHI],
  });

  const { data: chiEthData } = useReadContract({
    abi: StakingManagerAbi,
    functionName: "getUserTotalRewardsForToken",
    address: contractAddresses.StakingManager,
    args: [address!, contractAddresses.CHI_ETH_LP, contractAddresses.CHI],
  });

  // Calculate the sum using useMemo for optimization
  const sum = useMemo(() => {
    const uscEthRewards = uscEthData || 0n;
    const chiEthRewards = chiEthData || 0n;
    return formatUnits(uscEthRewards + chiEthRewards, 18);
  }, [uscEthData, chiEthData]);

  return {
    sum,
    uscEthData: {
      formattedUscEthData: formatUnits(uscEthData || 0n, 18),
    },
    chiEthData: {
      formattedChiEthData: formatUnits(chiEthData || 0n, 18),
    },
  };
};
